import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FwButtonToggleModule, FwIconModule } from '@flywheel-io/vision';

import { DirectivesModule } from '../common/directives.module';
import { CreateTaskComponent } from './create-task-dialog/create-task-dialog.component';
import { MaterialModule } from '../material.module';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { TaskDuplicatesDialogComponent } from './task-duplicates-dialog/task-duplicates-dialog.component';
import { TaskReviewComponent } from './task-review-dialog/task-review-dialog.component';
import { TasksListComponent } from './tasks-list/tasks-list.component';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: TasksListComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    DirectivesModule,
    FormsModule,
    MaterialModule,
    PipesModule,
    ReactiveFormsModule,
    ScrollingModule,
    SharedModule,
    FwIconModule,
    FwButtonToggleModule,
  ],
  exports: [
    TasksListComponent,
  ],
  declarations: [
    CreateTaskComponent,
    TasksListComponent,
    TaskDuplicatesDialogComponent,
    TaskReviewComponent,
  ],
})
export class TasksModule { }
